import React, { Component } from 'react'
import { connect } from 'react-redux'

import { ServiceItem } from '../molecules/ServiceItem'
import { List, Paper } from '@material-ui/core'
import { getServices, isGarageInitialized } from '../../store/garage/selectors'
import { initServices } from '../../store/garage/actions'
import {
  bookingRemoveService,
  bookingAddService
} from '../../store/booking/actions'
import { getBookingServices } from '../../store/booking/selectors'
import { Loading } from '../atoms/Loading'

export class ServicesSelector extends Component {
  componentDidMount() {
    const { initServices } = this.props
    initServices()
  }

  isServiceSelected = service => {
    const { selectedServices } = this.props
    return selectedServices.some(s => s.id === service.id)
  }

  handleOnChange = (service, newSelectedValue) => {
    newSelectedValue
      ? this.props.addService(service)
      : this.props.removeService(service)
  }

  render() {
    const { services, isGarageInitialized } = this.props

    if (isGarageInitialized) {
      return (
        <Paper>
          <List>
            {services.map(service => (
              <ServiceItem
                key={service.id}
                service={service}
                selected={this.isServiceSelected(service)}
                onChange={this.handleOnChange}
              />
            ))}
          </List>
        </Paper>
      )
    }
    return <Loading />
  }
}

const mapStateToProps = state => ({
  services: getServices(state),
  selectedServices: getBookingServices(state),
  isGarageInitialized: isGarageInitialized(state)
})

const mapDispatchToProps = dispatch => ({
  addService: service => dispatch(bookingAddService(service)),
  removeService: service => dispatch(bookingRemoveService(service)),
  initServices: () => dispatch(initServices())
})

export const LinkedServicesSelector = connect(
  mapStateToProps,
  mapDispatchToProps
)(ServicesSelector)
